import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {ErrorService} from '../services/error.service';
import {LoadingService} from '@shared/services/loading.service';
import {catchError, throwError} from 'rxjs';
import {StorageKeys} from '@core/constants/constants';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	const router = inject(Router);
	const errorService = inject(ErrorService);
	const loadingService = inject(LoadingService);

	return next(req).pipe(
		catchError((error: HttpErrorResponse) => {
			const isUnauthorized =
				error.error?.message === 'Not authenticated' || error.status === 401;
			// CORS / red caída en bootstrap de sesión (status 0). Sin esto el guard redirige a
			// ROOT y vuelve a pedir /user/info en bucle.
			const isUserInfoUnreachable =
				error.status === 0 && req.url.includes('/user/info');

			if (isUnauthorized || isUserInfoUnreachable) {
				localStorage.removeItem(StorageKeys.ACCESS_TOKEN);
				localStorage.removeItem(StorageKeys.ORIGINAL_TOKEN);
				loadingService.hide();
				loadingService.hideMaster();
				errorService.hideGeneralError();
				// No inyectar TranslateService aquí: circular con MultiHttpLoader → rompe i18n.
				router.navigate(['/login'], {
					state: isUserInfoUnreachable
						? {loginErrorKey: 'AUTHN.LOGIN.SESSION_LOAD_ERROR'}
						: undefined,
				});
			}

			return throwError(() => error);
		}),
	);
};
